import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { ChecklistService } from "../../services/checklist";
import { showErrorResponse } from "../../varibles/global";
import { IChecklist } from "../../varibles/interface";
import { checklistActions } from "./reducer";


function* getsWatcher(): Generator {
    try {
        const data = yield call(ChecklistService.get);
        yield put(checklistActions.getsSuccess(data as IChecklist[]));
    } catch (error) {
        yield put(checklistActions.getsFailure())
        showErrorResponse('Get locations failure', error);
    }
}

function* getStepsWatcher(): Generator {
    try {
        const data = yield call(ChecklistService.steps);
        yield put(checklistActions.getStepsSuccess(data as { [id: string]: string[] }));
    } catch (error) {
        yield put(checklistActions.getsFailure())
        showErrorResponse('Get data failure', error);
    }
}

export default function* checklistSaga() {
    yield all([
        takeEvery(checklistActions.gets.type, getsWatcher),
        takeEvery(checklistActions.getSteps.type, getStepsWatcher),

    ])
}
